'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Paging

function Paging(props) {
  var i18n = props.i18n,
      location = props.location,
      offset = props.offset,
      limit = props.limit,
      total = props.total;


  var activePage = Math.floor(offset / limit + 1);
  var totalPage = Math.ceil(total / limit);

  function createLinkList() {
    var list = [];
    var i = 1;

    while (i <= totalPage) {
      if (totalPage > 5 && i > 1 && i < activePage - 1 && activePage > 4 && i < totalPage - 2) {
        // renders the page-gap at the left hand side of the active page
        list.push(_react2.default.createElement(
          'li',
          { key: i },
          _react2.default.createElement(
            'span',
            { className: 'page-gap' },
            '\u2026'
          )
        ));
        i = activePage < totalPage - 1 ? activePage - 1 : totalPage - 2;
      } else if (totalPage > 5 && i < totalPage && i > activePage + 1 && i > 3 && activePage < totalPage - 3) {
        // renders the page-gap at the right hand side of the active page
        list.push(_react2.default.createElement(
          'li',
          { key: i },
          _react2.default.createElement(
            'span',
            { className: 'page-gap' },
            '\u2026'
          )
        ));
        i = totalPage;
      } else {
        list.push(_react2.default.createElement(
          'li',
          { key: i },
          i === activePage ? _react2.default.createElement(
            'span',
            { className: 'active-page' },
            activePage
          ) : _react2.default.createElement(
            _reactRouter.Link,
            { to: (0, _extends3.default)({}, location, { query: (0, _extends3.default)({}, location.query, { offset: limit * (i - 1) }) }) },
            i
          )
        ));
        i += 1;
      }
    }

    return list;
  }

  return _react2.default.createElement(
    'div',
    { className: 'result-pager' },
    _react2.default.createElement(
      'div',
      { className: 'pagination' },
      _react2.default.createElement(
        'ul',
        { className: 'pagination-ul' },
        _react2.default.createElement(
          'li',
          null,
          activePage > 1 ? _react2.default.createElement(
            _reactRouter.Link,
            { to: (0, _extends3.default)({}, location, { query: (0, _extends3.default)({}, location.query, { offset: offset > limit ? offset - limit : 0 }) }), className: 'prev-page' },
            _react2.default.createElement(
              'span',
              { className: 'for-reader' },
              i18n.hotelSearch.previousPage
            ),
            _react2.default.createElement('span', { className: 'icon-prev' })
          ) : null
        ),
        createLinkList(),
        _react2.default.createElement(
          'li',
          null,
          activePage < totalPage && _react2.default.createElement(
            _reactRouter.Link,
            { to: (0, _extends3.default)({}, location, { query: (0, _extends3.default)({}, location.query, { offset: offset + limit }) }), className: 'next-page' },
            _react2.default.createElement(
              'span',
              { className: 'for-reader' },
              i18n.hotelSearch.nextPage
            ),
            _react2.default.createElement('span', { className: 'icon-next' })
          )
        )
      )
    )
  );
}

Paging.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  offset: _react.PropTypes.number.isRequired,
  limit: _react.PropTypes.number.isRequired,
  total: _react.PropTypes.number.isRequired
};

exports.default = Paging;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Paging.js
// module id = 1211
// module chunks = 0